<template lang="html">
<div>
     <div class="inner-page">
          <Header>请输入验证码</Header>
          <div class="phone-text">已发送至手机 {{uPhone}}</div>
          <div class="reSent">
               <!-- <span>重新发送（58）</span> -->
          </div>
          <van-password-input
            class="pass-inpt"
            :mask="false"
            :value="value"
            :focused="showKeyboard"
            @focus="showKeyboard = true"
          />

     </div>

     <van-number-keyboard
       :show="showKeyboard"
       @input="onInput"
       @delete="onDelete"
       @blur="showKeyboard = false"
     />
</div>
</template>

<script>
import vEmits from "@/utils/vEmits";
import { passwordSet } from "@/api/login";
export default {
     data(){
          return{
              value:'',
              showKeyboard:true,
              uPhone:'',
              uPasscode:'',
              isPost:false
          }
     },
     methods:{
           onInput(key) {
             if(!this.isPost){
                 this.value = (this.value + key).slice(0, 6);
                 if(this.value.length == 6){
                     let vues = this;
                     this.isPost = true;
                     passwordSet({
                          cellphone:this.uPhone,
                          pwd:this.uPasscode,
                          verifyCode:this.value,
                     }).then(res => {
                          window.console.log(res);
                          vues.showKeyboard = false;
                          vEmits.$emit('show','修改成功');
                          vues.$router.push('login');
                     }).catch(errs => {
                          window.console.log(errs);
                          vues.$router.go(-1);
                     })
                 }
             }

           },
           onDelete() {
             if(!this.isPost){
                 this.value = this.value.slice(0, this.value.length - 1);
             }
           }
     },
     created:function(){

           this.uPhone = this.$route.query.uPhone;
           this.uPasscode = this.$route.query.uPasscode;

     }
}
</script>

<style lang="css" scoped>

.inner-page{
    position: absolute;
    left: 0px;
    top: 0px;
    height: 100%;
    background: white;
}

.phone-text{
    text-align: center;
    margin-top: 60px;
}

.reSent{
    text-align: center;
    margin-top: 6px;
}

.reSent span{
    font-size: 14px;
    color: #af2d2d;
}

.pass-inpt{
    margin-top: 30px;
}

</style>
